<template id="Matrimonial">
<Modele id="Matrimonial"/>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Matriomonial',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Immatriculation/Matrimonial.vue